import React from 'react';
import { FormattedMessage } from 'react-intl';

import css from './TrustBanner.module.css';

// Outline icons (24x24, stroke based) so they inherit the banner's text color.
const iconProps = {
  className: css.icon,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

const ShippingIcon = () => (
  <svg {...iconProps}>
    <path d="M1 4h14v12H1z" />
    <path d="M15 8h4l3 3v5h-7z" />
    <circle cx="5.5" cy="18.5" r="2" />
    <circle cx="18.5" cy="18.5" r="2" />
  </svg>
);

const ShieldIcon = () => (
  <svg {...iconProps}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <path d="M8.5 12l2.5 2.5 4.5-5" />
  </svg>
);

const CommunityIcon = () => (
  <svg {...iconProps}>
    <circle cx="9" cy="8" r="3.5" />
    <path d="M2 20c0-3.6 3.1-6 7-6s7 2.4 7 6" />
    <circle cx="17.5" cy="9" r="2.5" />
    <path d="M17 14c2.9.2 5 2.2 5 5" />
  </svg>
);

const SupportIcon = () => (
  <svg {...iconProps}>
    <path d="M4 14v-2a8 8 0 0 1 16 0v2" />
    <path d="M4 14h3v5H5a1 1 0 0 1-1-1z" />
    <path d="M20 14h-3v5h2a1 1 0 0 0 1-1z" />
    <path d="M17 19c0 1.5-1.5 2.5-4 2.5" />
  </svg>
);

const ITEMS = [
  { key: 'Shipping', Icon: ShippingIcon },
  { key: 'Authenticity', Icon: ShieldIcon },
  { key: 'Community', Icon: CommunityIcon },
  { key: 'Support', Icon: SupportIcon },
];

/**
 * Light-blue strip of marketplace value props shown above the footer on the home page.
 */
const TrustBanner = () => (
  <section className={css.root}>
    <ul className={css.items}>
      {ITEMS.map(({ key, Icon }) => (
        <li key={key} className={css.item}>
          <Icon />
          <div>
            <div className={css.title}>
              <FormattedMessage id={`CustomLandingPage.trust${key}Title`} />
            </div>
            <div className={css.desc}>
              <FormattedMessage id={`CustomLandingPage.trust${key}Desc`} />
            </div>
          </div>
        </li>
      ))}
    </ul>
  </section>
);

export default TrustBanner;
